import styled from 'styled-components';
import { customMedia } from 'styles/utils';
import {
  MobileBottomNavHeight,
  MobileFrameHeaderHeight,
  FrameHeaderHeight,
  FrameSidebarWidth,
} from 'styles/constants';
import { BlockSize, UiPosition } from 'libs/rendering/gltf/config';
import Button from 'components/Button';

export const MessagePane = styled.div(({ theme }) => ({
  position: 'relative',
  margin: theme.space[3],
  boxSizing: 'border-box',
  border: `1px solid ${theme.color.wfGrey300}`,
  borderRadius: 3,
}));

export const PanelStyled = styled.aside`
  z-index: 1011;
  position: fixed;
  top: ${FrameHeaderHeight}px;
  bottom: 0;
  ${props => props.position}: 0;
  left: 40;
  ${props => {
    if (props.position === 'left' && customMedia.lessThan('medium'))
      return `left: ${FrameSidebarWidth}px;`;
    return '';
  }}

  ${props =>
    props.position === 'left' && props.overrideLeftToZero && 'left: 0;'}
  width: ${props => {
    if (props.width !== 'auto') {
      return props.width;
    }
    if (props.large) {
      return BlockSize.desktopLargePanel;
    }
    if (props.position === 'left') {
      return `${UiPosition.panel}px`;
    }

    if (props.position === 'right') {
      return `${UiPosition.bigPanel}px`;
    }

    return BlockSize.desktopPanel;
  }};
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.color.wfWhite};
  border-${props =>
    `${props.position === 'left' ? 'right' : 'left'}: 1px solid ${
      props.theme.color.wfGrey200
    }`};
  transform: translateX(${props =>
    props.isOpen ? 0 : props.position === 'right' ? '100%' : '-100%'});
  margin-right: ${props =>
    props.isOpen && props.large && props.chatVisible
      ? BlockSize.desktopPanel
      : '0px'};

  ${props =>
    props.large &&
    customMedia.lessThan(props.chatVisible ? 'sxlarge' : 'large')`
    z-index: 1010;
    width: 100vw;
    margin-right: 0px;
  `};

  ${customMedia.lessThan('medium')`
    height: calc(100% - ${MobileFrameHeaderHeight}px - ${MobileBottomNavHeight}px);
    top: ${MobileFrameHeaderHeight}px;
    bottom: auto;
    right: auto;
    ${props => props.position === 'left' && 'left: 0;'};
    transition: transform 1s ease;
    width: 100vw;
  `};
`;

export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 2rem;
`;

export const PanelBorder = styled.div`
  z-index: 1011;
  position: absolute;
  top: 0;
  ${props => (props.position === 'left' ? 'right' : 'left')}: -1px;
  width: ${props => props.resizeArea}px;
  height: 100%;
  cursor: col-resize;
  transition: border 0.25s ease-in-out;

  &:hover {
    border-${props =>
      `${props.position === 'left' ? 'right' : 'left'}: 1px solid ${
        props.theme.color.primary
      }`};
  }
`;

export const ResizePanelWrapper = styled(PanelStyled)`
  min-width: ${BlockSize.desktopPanel};
  width: auto;
`;

export const PanelHeaderMainWrapper = styled.div`
  // position: absolute;
  width: inherit;
  ${props => props.position}: 0;
  // transform: translate(0px, -100%);
  height: 37px;
  background-color: ${props => props.theme.color.wfWhite};
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-right: 1px solid ${props => props.theme.color.wfGrey200};
  // border-left: 1px solid ${props => props.theme.color.wfGrey200};

  ${customMedia.lessThan('medium')`
    display: none;
  `};
`;

export const TitleWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-weight: bold;

  ${customMedia.lessThan('medium')`
    justify-content: center;
  `};
`;

export const BlockWrapper = styled.div`
  width: ${BlockSize.width};
  height: ${BlockSize.height};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const IconWrapper = styled.div`
  width: ${BlockSize.width};
  height: 100%;
  padding: 0;
  margin: ${props => `0 ${props.theme.spacing.xsmall}`};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ButtonCollapse = styled(Button)`desktopLargePanel
    color: ${props => props.theme.color.wfWhite};
  }
`;

export const Navigation = styled.nav`
  background-color: ${props => props.theme.color.greyLightest};
  padding: ${props =>
    `${props.theme.spacing.small} ${props.theme.spacing.medium}`};
  font-size: ${props => props.theme.font.size.small};
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  position: relative;
  min-height: ${props => props.tabHeight}px;
  ul {
    display: flex;
    justify-content: space-between;
    padding: 0;
    overflow-x: auto;
    a {
      color: ${props => props.theme.color.wfBlack};
    }
  }
`;

export const NavItem = styled.li`
  flex-shrink: 0;
  font-weight: ${props => props.theme.font.weight.xbold};
  &:hover {
    cursor: pointer;
  }
`;

export const ButtonStyled = styled(Button)`
  position: absolute;
  right: ${props => props.theme.spacing.small};
  top: 50%;
  transform: translateY(-50%);
`;

export const TooltipWrapper = styled.div`
  ${customMedia.lessThan('medium')`
    display: none;
  `};
`;
